import { ArchiveQuoteButton } from './ArchiveQuoteButton';
import { QuoteContactsButton } from './QuoteContactsButton';
import type { Quote } from './splitAwardGridTypes';

export function QuoteSellerName({ quote }: Readonly<{ quote: Quote }>) {
  return (
    <div className="flex items-center gap-1">
      <QuoteContactsButton quote={quote} />
      <ArchiveQuoteButton quote={quote} />
    </div>
  );
}
